import { useTranslation } from "react-i18next";
import {
  Box,
  SpanStyled,
  SubHeadingStyled,
} from "../../../../components/styled/Elements";
import { FormRadioWrapper } from "./AccessSettings";
import { Field, ErrorMessage, useFormikContext } from "formik";
import useCabinetOptions from "../../../../hooks/useCabinetOptions";
import { useUser } from "../../../../context/userContext";
import { useSelector } from "react-redux";
import AddMultipleUsers from "../../../../components/common/modals/multipleUsersModal/AddMultipleUsers";
import { SingleProfile } from "../../../../components/styled/AllImages";
import { useEffect } from "react";

const MyDepartmentOptions = () => {
  const { t, i18n: { language } } = useTranslation();
  const { setFieldValue, values } = useFormikContext();
  const { myDepartment, refetch } = useCabinetOptions();

  const { user } = useUser();
  const { usersList } = useSelector((state) => state.helper);

  const filteredUsers = usersList?.filter(
    (usr) => usr?.user_detail?.department_id == user?.department?.id
  ).map((usr) => {
    const uKey = `my_department_${usr.id}`;
    
    const existingReferral = values.referrals?.find(
      (ref) => ref.unique_id === uKey
    );

    return {
      ...usr,
      referralNote: existingReferral ? existingReferral.note : "",
      referralUniqueKey: uKey,
      shareReferrals: !!existingReferral,
    };
  });

  useEffect(() => {
    refetch();
  }, [language]);

  return (
    <Box className="optionsContent">
      <SubHeadingStyled
        size="15px"
        weight={700}
        color={"var(--text)"}
        className="px-4 pt-4 pb-0"
      >
        {t("my_department")}
      </SubHeadingStyled>

      <Box className="w-100 p-2">
        {myDepartment?.map((option, i) => (
          <Box
            key={option.id || i}
            className={`w-100 p-2 ${
              i !== myDepartment.length - 1 ? "separation-border" : ""
            }`}
          >
            <FormRadioWrapper>
              <Field
                type="radio"
                name="my_department_id"
                className="radio-input"
                value={option.id}
                checked={values.my_department_id === option.id}
                onChange={(e) => {
                  setFieldValue("my_department_id", Number(e.target.value));
                  setFieldValue("my_dept_ids", []);
                  setFieldValue("setting_id", null);
                }}
              />

              <SpanStyled
                size="16px"
                color="var(--text)"
                checked={values.my_department_id === option.id}
                className="radio-label"
              >
                {t(option.title)}
              </SpanStyled>
            </FormRadioWrapper>

            {(values.my_department_id === option.id && values.my_department_id === 4) && (
                <>
                  <AddMultipleUsers
                      title="add_users"
                      icon={<SingleProfile />}
                      selPlaceholder="SelectUser"
                      mainParents={filteredUsers}
                      selectedIds={values?.my_dept_ids}
                      setSelectedIds={(newIds) => {
                        setFieldValue('my_dept_ids', newIds);
                      }}
                  />
                  <ErrorMessage
                    name="my_dept_ids"
                    component="div"
                    className="text-danger text-sm mb-0 mt-1"
                  />
                </>
            )}
            {(values.my_department_id === option.id && values.my_department_id === 5) && (
                <>
                  <AddMultipleUsers
                      title="add_users"
                      icon={<SingleProfile />}
                      selPlaceholder="SelectUser"
                      selectedIds={values?.my_dept_ids}
                      mainParents={filteredUsers}
                      setSelectedIds={(newIds) => {
                        console.log('newIds: ', newIds);
                        setFieldValue('my_dept_ids', newIds);
                      }}
                  />
                  <ErrorMessage
                    name="my_dept_ids"
                    component="div"
                    className="text-danger text-sm mb-0 mt-1"
                  />
                </>
            )}
          </Box>
        ))}

        {/* ✅ ERROR MESSAGE */}
        <ErrorMessage
          name="my_department_id"
          component="div"
          className="text-danger text-sm mb-0 mt-1"
        />
      </Box>
    </Box>
  );
};

export default MyDepartmentOptions;